import { ApolloClient, InMemoryCache } from '@apollo/client';
import { relayStylePagination } from '@apollo/client/utilities';
import { apolloLink } from '../../../shared/data/apolloClient';

const alertDetailsMediaApolloClient = new ApolloClient({
  link: apolloLink,
  cache: new InMemoryCache({
    typePolicies: {
      Alert: {
        fields: {
          attachments: relayStylePagination(),
        },
      },
    },
  }),
});

export default alertDetailsMediaApolloClient;
